/*Menu*/

/*Menu*/

.links a {
	display: grid;
	grid-template-columns: 1fr 20px;
	grid-template-rows: 1fr;
	color: var(--cf-menu-ink);
	gap: 0px 0px;
	grid-template-areas: '. .';
	padding: 10px;
	text-align: start;
	transition: color ease-out 220ms;
}

.links a:hover {
	color: var(--cf-menu-ink-hover);
}

.menu-dialog {
	position: fixed;
	height: 100%;
	width: 100%;
	top: 0;
	border: 0px;
	background: rgba(0, 0, 0, 0);
	z-index: 100;
	padding: 0px;
}

/* Fade in and out with no JS (see `Menu`'s doc comment). The dialog keeps
   `display: block` even when closed (overriding the UA's `display: none`
   for `dialog:not([open])`) and is hidden with `visibility` instead, which
   every browser can delay: closing fades `opacity` out first and only then
   flips `visibility` to hidden (the `220ms` delay), opening flips it back
   immediately (`0s`). A `display` transition with `allow-discrete` would be
   the newer spelling, but WebKit still drops a closing `<dialog>` to
   `display: none` instantly, so Safari would get no fade-out.
   `visibility: hidden` also removes the closed menu from hit-testing, focus
   order and the accessibility tree, same as `display: none`. */
.menu-dialog {
	display: block;
	opacity: 0;
	visibility: hidden;
	transition:
		opacity 220ms ease-out,
		visibility 0s linear 220ms;
}

.menu-dialog[open] {
	opacity: 1;
	visibility: visible;
	transition:
		opacity 220ms ease-out,
		visibility 0s;
}

.menu {
	position: absolute;
	top: 0;
	inset-inline-end: 0px;
	padding: 10px;
	font-family: var(--content-font-family) !important;
	margin-top: calc(var(--top-bar-height) + 10px);
	margin-inline-end: 10px;
	min-height: 40px;
	width: 250px;
	border: 1px solid var(--cf-menu-border);
	border-radius: 8px;
	background: var(--cf-menu-surface);
	transition: background-color ease-out 220ms;
	overflow: hidden;
}

.menu > button,
.menu > a,
.menu > .language {
	display: flex;
	cursor: pointer;
	width: 100%;
	border: 0px;
	min-height: 40px;
	justify-content: space-between;
	align-items: center;
	background: transparent;
	padding: 0px 10px;
	color: var(--cf-menu-ink);
}

.menu > button:not(:disabled):hover,
.menu > a:hover {
	color: var(--cf-menu-ink-hover);
}

.menu > button:disabled {
	color: var(--cf-menu-ink-faint);
}

.menu section {
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid var(--cf-menu-border);
}

.menu > button:not(:last-child),
.menu > a:not(:last-child),
.menu > div:not(:last-child) {
	border-bottom: 1px solid var(--cf-menu-border);
}

.menu > a > span:last-of-type > div,
.menu > button > span:last-of-type > div {
	transition: background-color ease-out 220ms;
}

.menu span,
.menu a {
	font-family: var(--content-font-family) !important;
	font-size: 0.9rem;
}

.menu button,
.menu a {
	transition:
		color ease-out 220ms,
		font-weight ease-out 220ms;
}
.menu button:not(:disabled):hover,
.menu a:hover {
	font-weight: bold;
}

.menu > button:not(:disabled):hover svg,
.menu > a:hover svg {
	font-weight: bold;
}

.menu > a:hover > span:last-of-type > div,
.menu > button:not(:disabled):hover > span:last-of-type > div {
	background-color: var(--cf-menu-ink-hover) !important;
	transition: background-color ease-out 220ms;
}

.menu .links a {
	display: grid;
	grid-template-columns: 1fr 20px;
	grid-template-rows: 1fr;
	color: var(--cf-menu-ink);
	gap: 0px 0px;
	grid-template-areas: '. .';
	padding: 10px;
	text-align: start;
	transition: color ease-out 220ms;
}

.menu .links a:hover {
	color: var(--cf-menu-ink-hover);
}

.menu > div button:not(:disabled):hover > div {
	background-color: var(--cf-menu-ink-hover) !important;
	transition: background-color ease-out 220ms;
}

.menu > .language {
	padding: 0px 0px;
}

.menu .language > :first-child {
	padding-inline-start: 10px;
}

.menu .language > :last-child {
	padding-inline-end: 10px;
}

.menu > a {
	width: unset;
}

.menu > button,
.menu > a {
	cursor: pointer;
}

.menu > button:disabled {
	opacity: 0.5;
}

/* Icons are text-height and sit on the label's baseline. The icon's span
   is a line box of its own, with the same font, size and line-height as
   the label span (`.menu span` above), so the two boxes are the same height
   and both get centred in the row -- their baselines line up. The SVG sits
   inline on that baseline at `1em`: the label's own size. It's scaled as a
   whole (Lucide's stroke scales with it), so the icon's proportions don't
   change. (Tailwind's preflight makes every `svg` a block; inline-block is
   what lets it sit on a baseline at all.) */
.menu > button > :last-child,
.menu > a > :last-child {
	display: block;
}

.menu > button > :last-child > svg,
.menu > a > :last-child > svg {
	display: inline-block;
	width: 1em;
	height: 1em;
	/* Lucide keeps 2 of its 24 viewBox units empty below the drawing, so
	   the box's bottom is not where the strokes end: lowering it by that
	   much puts the strokes, not the padding, on the baseline. */
	vertical-align: calc(-2em / 24);
	/* Keeps the icon from growing its line box (a 1em box is taller than
	   the font's ascent), which would push it off the label's baseline once
	   the row centres the two boxes. Paint is unaffected. */
	margin-top: -1em;
}

.menu .font-button {
	display: grid;
	grid-auto-columns: 1fr;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 1fr;
	gap: 0px 0px;
	grid-template-areas: '. . .';
	min-height: 40px;
	padding: 0px 10px;
}

.menu .font-button span {
	display: flex;
	justify-content: center;
	align-items: center;
}

.menu .font-button button {
	height: 32px;
	border: 0px;
	cursor: pointer;
	background: transparent;
	margin-top: auto;
	margin-bottom: auto;
}

.menu .font-button button:first-of-type {
	margin-inline-end: auto;
}

.menu .font-button button:last-of-type {
	margin-inline-start: auto;
}

.menu .legal {
	border-top: 1px solid var(--cf-menu-border);
	font-size: 0.7rem;
	padding: 5px;
	font-family: var(--content-font-family);
}

.menu .legal > div {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 20px;
	gap: 8px 10px;
	grid-template-areas:
		'copyright copyright'
		'. .';
}

.menu .legal > div > :first-child {
	grid-area: copyright;
	line-height: 1.5;
}

.menu .legal > div > div,
.menu .legal a {
	color: var(--cf-menu-ink-muted);
	transition: color ease-out 220ms;
}

.menu .legal a:hover {
	color: var(--cf-menu-ink-hover);
}

/* A destructive row (`MenuButton.SignOut`). Red at rest and on hover --
   it doesn't take the accent colour like every other row. Always the last
   row, so the row above's own bottom border is its divider. */
.menu > button.danger,
.menu > button.danger:not(:disabled):hover {
	color: var(--cf-menu-ink-danger);
}

/* The row for the page or section the reader is on (`MenuButton.Item`). */
.menu > button.active {
	color: var(--cf-menu-ink-hover);
	font-weight: bold;
}
